import DatePickerLocale from 'rmc-date-picker/es/locale/zh_CN';
export default DatePickerLocale;